var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-switch",class:{ active: _vm.value },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"handle"})])}
var staticRenderFns = []

export { render, staticRenderFns }